module.exports = __webpack_public_path__ + "img/ld-person.2879b41d.png";